import React from 'react';

const TypingIndicator = () => {
  return (
    <div className="flex justify-start mb-4">
      <div className="flex items-start space-x-2">
        <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
          <svg viewBox="0 0 24 24" className="w-4 h-4 text-primary-foreground">
            <path 
              fill="currentColor" 
              d="M12 2L3.09 8.26L4 21L12 17L20 21L20.91 8.26L12 2Z"
            />
            <circle cx="12" cy="10" r="1.5" fill="var(--color-secondary)" />
          </svg>
        </div>
        <div className="bg-card border border-border rounded-lg p-3 shadow-tier-1">
          <div className="flex items-center space-x-1">
            <span className="text-sm text-muted-foreground">Dai está digitando</span>
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
              <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
              <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;